module.exports = __webpack_public_path__ + "media/images/deliver-blue-53269802a647423d5997d3367096636c.svg";